export default "__VITE_ASSET__DNhG2eX2__"